<template>
  <MainLayout id="app">
    <link
      rel="stylesheet"
      href="https://cdn.materialdesignicons.com/2.5.94/css/materialdesignicons.min.css"
    />
    <router-view />
  </MainLayout>
</template>

<script>
import MainLayout from "./views/MainLayout";

export default {
  name: "App",

  components: {
    MainLayout,
  },
}

</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Baloo%20Chettan%202");

$body-font-family: 'Baloo Chettan 2';

.v-application {
   font-family: $body-font-family, sans-serif !important;
 }
</style>